//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// chrome-drawer imports
import * as s from "./ChromeDrawer.styles";

export interface IChromeDrawer {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  open: boolean;
}

//////////////////
// COMPONENT
//////////////////
export const ChromeDrawer = ({ open, style, children }: IChromeDrawer) => {
  return (
    <div style={{ ...(open ? s.container : { ...s.container, ...s.hidden }), ...style }}>
      <div style={s.content}>{children}</div>
    </div>
  );
};
